export function getWindowDimensions() {
  const { innerWidth: width } = window;
  let screenSize;
  if (width < 576) {
    screenSize = "small";
  } else if (width >= 576 && width < 992) {
    screenSize = "medium";
  } else if (width >= 992) {
    screenSize = "large";
  }
  return {
    isScreenSizeLarge: screenSize === "large",
    isScreenSizeMedium: screenSize === "medium",
    isScreenSizeSmall: screenSize === "small",
  };
}
